export default {
  pt: {
    pageTitle: "Leitura da tag",
    mainTitle: "Aponte a câmera para o QR code da tag",
    description:
      "A tag fica no adesivo colado na sua bike. Aponte a câmera para o código para continuarmos.",
    invalidFormatTitle: "QR code inválido",
    invalidFormatRetry: "Tentar novamente",
    permissionDeniedTitle: "Câmera bloqueada",
    permissionDeniedDescription:
      "Precisamos da câmera para ler a tag. Permita o acesso e tente novamente.",
    permissionDeniedRetry: "Tentar novamente",
    cameraErrorTitle: "Não foi possível abrir a câmera",
    cameraErrorDescription:
      "Verifique se outro aplicativo não está usando a câmera e tente novamente.",
    genericErrorTitle: "Não foi possível ler a tag",
    genericErrorDescription: "Tente ler o QR code novamente.",
    handoffDescription:
      "Para ler a tag, escaneie o QR code com a câmera do seu celular e continue por lá.",
    redirectDialogTitle: "Ativar esta tag?",
    redirectDialogBody:
      "Para ativar a tag, vamos te levar para a página de ativação. Deseja continuar?",
    redirectDialogConfirmButton: "Sim, continuar",
    redirectDialogCancelButton: "Cancelar",
  },

  en: {
    pageTitle: "Tag reading",
    mainTitle: "Point the camera at the tag's QR code",
    description:
      "The tag is on the sticker attached to your bike. Point the camera at the code so we can continue.",
    invalidFormatTitle: "Invalid QR code",
    invalidFormatRetry: "Try again",
    permissionDeniedTitle: "Camera blocked",
    permissionDeniedDescription:
      "We need camera access to read the tag. Allow access and try again.",
    permissionDeniedRetry: "Try again",
    cameraErrorTitle: "Could not open the camera",
    cameraErrorDescription: "Check if another application is using the camera and try again.",
    genericErrorTitle: "Could not read the tag",
    genericErrorDescription: "Try scanning the QR code again.",
    handoffDescription:
      "To read the tag, scan the QR code with your phone's camera and continue from there.",
    redirectDialogTitle: "Activate this tag?",
    redirectDialogBody:
      "To activate the tag, we'll take you to the activation page. Do you want to continue?",
    redirectDialogConfirmButton: "Yes, continue",
    redirectDialogCancelButton: "Cancel",
  },
};
